/* import __COLOCATED_TEMPLATE__ from './bounds-area.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import type Bounds from '../../models/graph-editor/bounds';
import { type SafeString } from 'handlebars';
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

interface Args {
  bounds?: Bounds;
}

export default class GraphEditorBoundsAreaComponent extends Component<Args> {
  get style(): SafeString {
    if (this.args.bounds) {
      return sanitizeHtml(`
      --x: ${this.args.bounds.left}px;
      --y: ${this.args.bounds.top}px;
      --width: ${this.args.bounds.width}px;
      --height: ${this.args.bounds.height}px;
      --display: block;
    `);
    } else {
      return sanitizeHtml(`
      --display: none;
    `);
    }
  }
}
